module.exports = '/ng-templates/features/search/kp-search-page/kp-search-page.tpl.ftl';
